import React, { Component } from 'react';
const win=window;


class Highcharts extends Component {
	constructor(props) {
		super(props);
	}



   componentDidMount() {
    let titleText = this.props.title;
  	let types =this.props.charttype;

       // window.test();
      setTimeout(()=>{

          win.Highcharts.chart(this.refs.highcharts, {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: types,
                options3d: {
                  enabled: true,
                  alpha: 45,
                  beta: 0
                }
            },
            title: {
                text: titleText
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.y}</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    depth: 35,
                    dataLabels: {
                        enabled: false,
                    }
                }
            },
            series: [{
                name: this.props.name,
                colorByPoint: true,
                data: this.props.data
            }]
        });


      },200);


    }





  render() {
    return (
      <div ref="highcharts" style={{width:'98%',float: 'left',margin: '25px 0px'}} ></div>

    );
  }
}

export default Highcharts;



// WEBPACK FOOTER //
// ./src/components/Highcharts.js